import React from 'react'
import PropTypes from 'prop-types'
import Button from '../Button'
import Icon from '../../Icon'
import { useJss } from '../../../layout/jss'

function DownloadButton({ onClick }) {
  const useStyles = useJss({
    button: {
      color: '#760074',
      backgroundColor: '#fff',
      padding: '10px',
      marginLeft: '5px',
    },
  })
  const classes = useStyles()
  return (
    <Button
      variant="icon"
      className={classes.button}
      onClick={onClick}
    >
      <Icon color="#760074" iconName="CloudDownload" />
    </Button>
  )
}

DownloadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default DownloadButton
